document.addEventListener("DOMContentLoaded", () => {
  /* ============================================================
     HELPERS
  ============================================================ */

  function getGiftCardElements() {
    return {
      giftCardBtn: document.getElementById("add-gift-card"),
      giftCardModal: document.getElementById("gift-card-modal"),
      closeGiftCard: document.getElementById("close-gift-card"),
      saveGiftCard: document.getElementById("save-gift-card"),
      giftWrapBlock: document.getElementById("gift-wrap-block"),

      labelEl: document.getElementById("gift-card-btn-label"),
      priceEl: document.getElementById("gift-card-btn-price"),

      zoomModal: document.getElementById("gift-card-modal-drawer"),
      zoomImg: document.getElementById("gift-card-drawer-img"),
      zoomClose: document.getElementById("gift-card-drawer-close"),
    };
  }

  /* ============================================================
     GIFT CARD LIMIT CHECK
  ============================================================ */

  async function checkGiftCardLimit() {
    const {
      giftCardBtn,
      labelEl,
      priceEl
    } = getGiftCardElements();

    if (!giftCardBtn) return;

    try {
      const response = await fetch("/cart.js", {
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Unable to fetch cart.");
      }

      const cart = await response.json();

      let count = 0;

      cart.items.forEach((item) => {
        const productType = (item.product_type || "").toLowerCase();
        const handle = (item.handle || "").toLowerCase();

        if (
          productType.includes("gift card") ||
          handle.includes("gift-card")
        ) {
          count += item.quantity;
        }
      });

      if (count >= 2) {
        giftCardBtn.disabled = true;
        giftCardBtn.classList.add("disabled");

        if (labelEl) {
          labelEl.textContent = "Gift card limit reached (2)";
        }

        if (priceEl) {
          priceEl.textContent = "";
        }
      } else {
        giftCardBtn.disabled = false;
        giftCardBtn.classList.remove("disabled");

        if (labelEl) {
          labelEl.textContent = "Add an Audrey’s Gift Card";
        }

        if (priceEl) {
          priceEl.textContent = "£1.00";
        }
      }
    } catch (error) {
      console.error("Gift card limit check failed:", error);
    }
  }

  /* ============================================================
     GIFT WRAP CART CHECK
  ============================================================ */

  async function checkGiftWrapInCart() {
    const btn = document.getElementById("gift-wrap-btn");

    if (!btn) return;

    const variantId = btn.dataset.variantId;

    if (!variantId) return;

    try {
      const response = await fetch("/cart.js", {
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Unable to fetch cart.");
      }

      const cart = await response.json();

      const exists = cart.items.some(
        (item) => String(item.variant_id) === String(variantId)
      );

      btn.classList.toggle("active", exists);
    } catch (error) {
      console.error("Gift wrap cart check failed:", error);
    }
  }

  /* ============================================================
     UPDATE GIFT WRAP
  ============================================================ */

  async function updateGiftWrap(variantId, action) {
    const isAdding = action === "add";

    const url = isAdding
      ? "/cart/add.js"
      : "/cart/update.js";

    const data = isAdding
      ? {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        }
      : {
          updates: {
            [variantId]: 0,
          },
        };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(
        error.description ||
        error.message ||
        "Unable to update gift wrapping."
      );
    }

    await response.json();

    await refreshCartDrawerUI();
  }

  /* ============================================================
     ADD GIFT CARD TO CART
  ============================================================ */

  async function addToCart(items) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));

      throw new Error(
        error.description ||
        error.message ||
        "Unable to add item to cart."
      );
    }

    await response.json();

    await refreshCartDrawerUI();
  }

  /* ============================================================
     SAVE GIFT CARD
  ============================================================ */

  async function saveGiftCardToCart(button) {
    if (button.classList.contains("loading")) return;

    const variant = document.querySelector(
      'input[name="gift-card-variant"]:checked'
    );

    const messageField = document.querySelector(
      'textarea[name="attributes[Message]"]'
    );

    if (!variant) {
      alert("Please select a gift card design.");
      return;
    }

    button.classList.add("loading");
    button.disabled = true;

    try {
      /* --------------------------------------------
         Check existing gift cards
      -------------------------------------------- */

      const response = await fetch("/cart.js", {
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Unable to fetch cart.");
      }

      const cart = await response.json();

      let count = 0;

      cart.items.forEach((item) => {
        const productType = (item.product_type || "").toLowerCase();
        const handle = (item.handle || "").toLowerCase();

        if (
          productType.includes("gift card") ||
          handle.includes("gift-card")
        ) {
          count += item.quantity;
        }
      });

      if (count >= 2) {
        alert("You can only add up to 2 gift cards.");

        await checkGiftCardLimit();

        return;
      }

      /* --------------------------------------------
         Build line item properties
      -------------------------------------------- */

      const properties = {};

      const message = messageField
        ? messageField.value.trim()
        : "";

      if (message) {
        properties.Message = message;
      }

      /* --------------------------------------------
         Add gift card
      -------------------------------------------- */

      await addToCart([
        {
          id: Number(variant.value),
          quantity: 1,
          properties,
        },
      ]);

      /*
        IMPORTANT:
        refreshCartDrawerUI() replaces the modal,
        so query the NEW elements after refresh.
      */

      const {
        giftCardModal,
        giftWrapBlock
      } = getGiftCardElements();

      if (giftCardModal) {
        giftCardModal.style.display = "none";
      }

      giftWrapBlock?.classList.remove("is-hidden");

      await checkGiftCardLimit();
    } catch (error) {
      console.error("Gift card add failed:", error);

      alert(
        error.message ||
        "Something went wrong while adding the gift card."
      );
    } finally {
      /*
        The old button may no longer exist after drawer refresh,
        so get the current one.
      */

      const currentSaveButton =
        document.getElementById("save-gift-card");

      if (currentSaveButton) {
        currentSaveButton.classList.remove("loading");
        currentSaveButton.disabled = false;
      }
    }
  }

  /* ============================================================
     REFRESH CART DRAWER
  ============================================================ */

  async function refreshCartDrawerUI() {
    try {
      const response = await fetch(
        `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
      );

      if (!response.ok) {
        throw new Error("Unable to refresh cart drawer.");
      }

      const sections = await response.json();

      const parser = new DOMParser();

      /* ----------------------------------------------------------
         CART DRAWER
      ---------------------------------------------------------- */

      if (sections["cart-drawer"]) {
        const newDoc = parser.parseFromString(
          sections["cart-drawer"],
          "text/html"
        );

        /*
          Prefer replacing the whole cart drawer content when possible.

          This is important because the gift wrap / gift card markup
          might not live directly inside #CartDrawer-CartItems.
        */

        const currentDrawer =
          document.querySelector("cart-drawer");

        const newDrawer =
          newDoc.querySelector("cart-drawer");

        if (currentDrawer && newDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        } else {
          /*
            Fallback to CartDrawer-CartItems.
          */

          const currentItems =
            document.querySelector("#CartDrawer-CartItems");

          const newItems =
            newDoc.querySelector("#CartDrawer-CartItems");

          if (currentItems && newItems) {
            currentItems.innerHTML = newItems.innerHTML;
          }
        }
      }

      /* ----------------------------------------------------------
         CART ICON BUBBLE
      ---------------------------------------------------------- */

      if (sections["cart-icon-bubble"]) {
        const bubbleDoc = parser.parseFromString(
          sections["cart-icon-bubble"],
          "text/html"
        );

        const currentBubble =
          document.querySelector("#cart-icon-bubble");

        const newBubble =
          bubbleDoc.querySelector("#cart-icon-bubble");

        if (currentBubble && newBubble) {
          currentBubble.innerHTML =
            newBubble.innerHTML;
        }
      }

      /*
        NO event rebinding is required.

        All gift feature clicks are handled by
        the delegated document click listener below.
      */

      await Promise.all([
        checkGiftWrapInCart(),
        checkGiftCardLimit(),
      ]);

      /*
        Let other theme/custom scripts know that
        the cart drawer has been refreshed.
      */

      document.dispatchEvent(
        new CustomEvent("cart:gift-features-refreshed")
      );
    } catch (error) {
      console.error("Cart drawer refresh failed:", error);
    }
  }

  /* ============================================================
     SINGLE DELEGATED CLICK HANDLER
     ------------------------------------------------------------
     This is the important fix.

     document never gets replaced when Shopify refreshes the
     cart drawer, so these listeners continue working.
  ============================================================ */

  document.addEventListener("click", async (event) => {

    /* ==========================================================
       GIFT WRAP
    ========================================================== */

    const giftWrapBtn =
      event.target.closest("#gift-wrap-btn");

    if (giftWrapBtn) {
      event.preventDefault();

      if (
        giftWrapBtn.classList.contains("loading") ||
        giftWrapBtn.disabled
      ) {
        return;
      }

      const variantId =
        giftWrapBtn.dataset.variantId;

      if (!variantId) {
        console.warn(
          "Gift wrap variant ID is missing."
        );

        return;
      }

      const active =
        giftWrapBtn.classList.contains("active");

      giftWrapBtn.classList.add("loading");
      giftWrapBtn.disabled = true;

      try {
        await updateGiftWrap(
          variantId,
          active ? "remove" : "add"
        );
      } catch (error) {
        console.error(
          "Gift wrap update failed:",
          error
        );

        alert(
          error.message ||
          "Something went wrong while updating gift wrapping."
        );
      } finally {
        /*
          Drawer may have been replaced,
          so query the NEW button.
        */

        const currentBtn =
          document.getElementById("gift-wrap-btn");

        if (currentBtn) {
          currentBtn.classList.remove("loading");
          currentBtn.disabled = false;
        }
      }

      return;
    }

    /* ==========================================================
       OPEN GIFT CARD MODAL
    ========================================================== */

    const addGiftCardBtn =
      event.target.closest("#add-gift-card");

    if (addGiftCardBtn) {
      event.preventDefault();

      if (
        addGiftCardBtn.disabled ||
        addGiftCardBtn.classList.contains("disabled")
      ) {
        return;
      }

      const {
        giftCardModal,
        giftWrapBlock
      } = getGiftCardElements();

      if (giftCardModal) {
        giftCardModal.style.display = "block";
      }

      giftWrapBlock?.classList.add("is-hidden");

      return;
    }

    /* ==========================================================
       CLOSE GIFT CARD MODAL
    ========================================================== */

    const closeGiftCardBtn =
      event.target.closest("#close-gift-card");

    if (closeGiftCardBtn) {
      event.preventDefault();

      const {
        giftCardModal,
        giftWrapBlock
      } = getGiftCardElements();

      if (giftCardModal) {
        giftCardModal.style.display = "none";
      }

      giftWrapBlock?.classList.remove("is-hidden");

      return;
    }

    /* ==========================================================
       SAVE GIFT CARD
    ========================================================== */

    const saveGiftCardBtn =
      event.target.closest("#save-gift-card");

    if (saveGiftCardBtn) {
      event.preventDefault();

      await saveGiftCardToCart(
        saveGiftCardBtn
      );

      return;
    }

    /* ==========================================================
       GIFT CARD IMAGE ZOOM
    ========================================================== */

    const zoomButton =
      event.target.closest(".gift-card-drawer-zoom");

    if (zoomButton) {
      event.preventDefault();
      event.stopPropagation();

      const src =
        zoomButton.dataset.image;

      const {
        zoomModal,
        zoomImg
      } = getGiftCardElements();

      if (
        src &&
        zoomModal &&
        zoomImg
      ) {
        zoomImg.src = src;
        zoomModal.classList.add("is-active");
      }

      return;
    }

    /* ==========================================================
       CLOSE ZOOM BUTTON
    ========================================================== */

    const zoomClose =
      event.target.closest("#gift-card-drawer-close");

    if (zoomClose) {
      event.preventDefault();

      const {
        zoomModal,
        zoomImg
      } = getGiftCardElements();

      zoomModal?.classList.remove("is-active");

      if (zoomImg) {
        zoomImg.src = "";
      }

      return;
    }

    /* ==========================================================
       CLICK OUTSIDE ZOOM CONTENT
    ========================================================== */

    const zoomModal =
      event.target.closest("#gift-card-modal-drawer");

    if (zoomModal) {
      const content =
        zoomModal.querySelector(
          ".gift-card-drawer-content"
        );

      if (
        content &&
        !content.contains(event.target)
      ) {
        zoomModal.classList.remove("is-active");

        const zoomImg =
          zoomModal.querySelector(
            "#gift-card-drawer-img"
          );

        if (zoomImg) {
          zoomImg.src = "";
        }
      }

      return;
    }

    /* ==========================================================
       CART REMOVE BUTTON

       We don't bind directly because Dawn can replace these too.
    ========================================================== */

    const removeButton =
      event.target.closest(
        ".cart-remove-button, cart-remove-button a, cart-remove-button button"
      );

    if (removeButton) {
      /*
        Dawn performs the actual removal.

        Wait briefly, then update our gift state.
      */

      setTimeout(() => {
        checkGiftCardLimit();
        checkGiftWrapInCart();
      }, 500);
    }
  });

  /* ============================================================
     SHOPIFY / DAWN CART DRAWER MUTATION WATCHER

     This handles this situation:

     1. User adds NORMAL product
     2. Dawn refreshes cart drawer
     3. Gift buttons are replaced

     Event delegation already keeps clicks working.

     This observer simply updates active/limit states when the
     drawer changes.
  ============================================================ */

  const cartDrawer =
    document.querySelector("cart-drawer");

  if (cartDrawer) {
    let observerTimer;

    const observer =
      new MutationObserver(() => {
        clearTimeout(observerTimer);

        observerTimer = setTimeout(() => {
          checkGiftWrapInCart();
          checkGiftCardLimit();
        }, 150);
      });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  /* ============================================================
     GLOBAL HELPERS
  ============================================================ */

  window.rebindGiftFeatures = () => {
    /*
      Kept for compatibility with any existing code that calls it.

      We don't actually need to bind listeners anymore because
      document-level event delegation handles that.
    */

    checkGiftWrapInCart();
    checkGiftCardLimit();
  };

  window.refreshGiftCartDrawer =
    refreshCartDrawerUI;

  /* ============================================================
     INITIAL STATE
  ============================================================ */

  checkGiftWrapInCart();
  checkGiftCardLimit();


  
});